import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

import createRootReducer from './ducks/index';
import rootSaga from './sagas';

const middlewares = [];

const sagaMiddleware = createSagaMiddleware();

middlewares.push(sagaMiddleware);

const composer = applyMiddleware(...middlewares);

const store = createStore(createRootReducer(), composer);

sagaMiddleware.run(rootSaga);

export default store;
